import type { IPaymentParam } from "./createDraftOrder";
import type { MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";

type TDiscountClass = "ORDER" | "PRODUCT" | "SHIPPING";

export interface ICalculatedDraftOrder {
  customer: { id: string };
  totalPriceSet: { shopMoney: MoneyV2 };
  subtotalPriceSet: { shopMoney: MoneyV2 };
  discountCodes: string[];
  platformDiscounts: {
    automaticDiscount: boolean;
    title: string;
    discountClasses: TDiscountClass[];
    totalAmountPriceSet: { shopMoney: MoneyV2 };
  }[];
  lineItems: {
    discountedTotalSet: { shopMoney: MoneyV2 };
    originalTotalSet: { shopMoney: MoneyV2 };
  }[];
  taxLines: {
    priceSet: { shopMoney: MoneyV2 };
    title: string;
  }[];
  totalTaxSet: { shopMoney: MoneyV2 };
  totalDiscountsSet: { shopMoney: MoneyV2 };
  shippingLine?: {
    originalPriceSet: { shopMoney: MoneyV2 }; // 원래 가격
    discountedPriceSet: { shopMoney: MoneyV2 }; // 할인된 가격
  };
  warnings: { errorCode: string; field: string; message: string }[];
}

const API_URL = {
  thisisneverthat: "https://47qqezisxqdm74ycuxv3wg5pkm0yxdgm.lambda-url.ap-northeast-2.on.aws/", // thisisneverthat_draft_order_calculate_intl
  yeseyesee: "https://jzh5o2q5fcau5vur3dt77ejlta0lklhj.lambda-url.ap-northeast-2.on.aws/", // yeseyesee_draft_order_calculate_intl
  khakis: "https://2qi3rumnsepqnp56foi2m5w4qm0wwxyt.lambda-url.ap-northeast-2.on.aws/", // khakis_draft_order_calculate_intl
  sunlove: "https://mvi4wfgtoymlaipxc2gwutjt2a0kouyw.lambda-url.ap-northeast-2.on.aws/", // sunlove_draft_order_calculate_intl
};

interface ICalculateDraftOrder {
  message: string;
  data?: ICalculatedDraftOrder;
}

export default async function calculateDraftOrderV2({
  shop,
  param,
}: {
  shop: string;
  param: IPaymentParam;
}): Promise<ICalculateDraftOrder | undefined> {
  const lambdaUrl = API_URL[shop as keyof typeof API_URL];
  if (!lambdaUrl) return;

  try {
    const response = await fetch(lambdaUrl, { method: "POST", body: JSON.stringify(param) });
    const result = await response.json();
    if (response.ok && result.message === "Success") {
      return { message: "Success", data: result.data };
    }

    return { message: result.message };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`[LAMBDA][Calculate Draft Order] Failed to fetch : ${message}`);
  }
}
